import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, StateConfig, StateTransferType } from '@spartacus/core';
import { clearSelectedFacetsMetaReducer, reducerProvider, reducerToken } from './reducers';
import { SEARCH_FEATURE } from './search-state';
import { SearchStatePersistenceService } from './search-state-persistence.service';

function searchStatePersistenceFactory(searchStatePersistenceService: SearchStatePersistenceService): () => void {
  return () => searchStatePersistenceService.sync();
}

function searchStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [SEARCH_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    StoreModule.forFeature(SEARCH_FEATURE, reducerToken, { metaReducers: [clearSelectedFacetsMetaReducer] }),
    ConfigModule.withConfigFactory(searchStoreConfigFactory),
  ],
  providers: [
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = searchStatePersistenceFactory(inject(SearchStatePersistenceService));

      return initializerFn();
    }),
  ],
})
export class ProductStoreModule {}
